import React, { useLayoutEffect } from 'react';
import {
  CapaPcbServiceType,
  CapaQuotationServiceType
} from '@generated/graphql';
import { RfqDetailData } from '@routes/Common/type';
import RfqFilesThumbnailViewer from '@routes/Common/RfqFilesThumbnailViewer';
import RfqDetailInfoPresenter from './RfqDetailInfoPresenter';
import RfqDrawingFilesPresenter from './RfqDrawingFilesPresenter';
import RfqReferenceImagePresenter from './RfqReferenceImagePresenter';
import RfqDetailedRequestPresenter from './RfqDetailedRequestPresenter';
import RfqProjectInfoPresenter from './RfqProjectInfoPresenter';
import RfqReferenceFilesPresenter from './RfqReferenceFilesPresenter';
import { Divider } from '@material-ui/core';
import RfqPcbProduceFilesPresenter from './RfqPcbProduceFilesPresenter';
import RfqPcbAssembleFilesPresenter from './RfqPcbAssembleFilesPresenter';
import RfqCircuitAssemblyDetailPresenter from './RfqCircuitAssemblyDetailPresenter';
import { useStyles } from './useStyles';

interface Props {
  matches?: boolean;
  data?: RfqDetailData;
  isPreview?: boolean;
}

const RfqDetailPresenter: React.FC<Props> = ({
  matches,
  data,
  isPreview
}: Props) => {
  const classes = useStyles();

  const serviceType = data?.serviceType ?? undefined;
  const isDesign = serviceType === CapaQuotationServiceType.Design;
  const isPcb = serviceType === CapaQuotationServiceType.Pcb;
  const pcbServices = (data?.pcb?.services ?? []).map(
    (service) => service.serviceType
  );
  const hasCuircuitDesign = pcbServices?.includes(
    CapaPcbServiceType.CircuitDesign
  );
  const hasCircuitFabrication = pcbServices?.includes(
    CapaPcbServiceType.CircuitFabrication
  );
  const hasCircuitAssembly = pcbServices?.includes(
    CapaPcbServiceType.CircuitAssembly
  );

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [data]);

  if (!data || !data.id) return null;

  return (
    <div className={classes.container}>
      {!hasCuircuitDesign && (
        <RfqFilesThumbnailViewer
          matches={matches}
          data={data}
          isPreview={isPreview}
        />
      )}
      <RfqDetailInfoPresenter matches={matches} data={data} />

      <Divider />

      {!isPcb && (
        <>
          {isDesign ? (
            <RfqReferenceImagePresenter matches={matches} data={data} />
          ) : (
            <RfqDrawingFilesPresenter matches={matches} data={data} />
          )}

          <Divider />
        </>
      )}

      {!hasCuircuitDesign && (hasCircuitFabrication || hasCircuitAssembly) && (
        <>
          <RfqPcbProduceFilesPresenter matches={matches} data={data} />
          <Divider />
        </>
      )}
      {!hasCuircuitDesign && hasCircuitAssembly && (
        <>
          <RfqPcbAssembleFilesPresenter matches={matches} data={data} />{' '}
          <Divider />
        </>
      )}
      {!hasCuircuitDesign && hasCircuitAssembly && (
        <>
          <RfqCircuitAssemblyDetailPresenter matches={matches} data={data} />{' '}
          <Divider />
        </>
      )}
      <RfqDetailedRequestPresenter matches={matches} data={data} />
      <Divider />

      {!isDesign && (
        <>
          <RfqReferenceFilesPresenter matches={matches} data={data} />
          <Divider />
        </>
      )}

      <RfqProjectInfoPresenter matches={matches} data={data} />
    </div>
  );
};

export default RfqDetailPresenter;
